export const AFFILIATE_PROGRAM_CREATIVES_EDIT_ROUTE_NAME = Symbol('affiliate-program.creatives.edit');
export const AFFILIATE_PROGRAM_CREATIVES_CREATE_ROUTE_NAME = Symbol('affiliate-program.creatives.create');
export const AFFILIATE_PROGRAM_CREATIVES_BULK_ADD_ROUTE_NAME = Symbol('affiliate-program.creatives.bulk-add');

export const AFFILIATE_PROGRAM_CREATIVES_OPTIONS_URL = 'admin/creatives/options';
export const AFFILIATE_PROGRAM_CREATIVES_OPTIONS_QUERY_KEY = 'affiliate-program.creatives.options';

export const AFFILIATE_PROGRAM_CREATIVES_GET_URL = 'admin/creatives/:id';
export const AFFILIATE_PROGRAM_CREATIVES_GET_QUERY_KEY = 'affiliate-program.creatives.get';

export const AFFILIATE_PROGRAM_CREATIVES_COMPANIES_URL = 'admin/creatives/list_advertising_company';
export const AFFILIATE_PROGRAM_CREATIVES_COMPANIES_QUERY_KEY = 'affiliate-program.creatives.companies';

export const AFFILIATE_PROGRAM_CREATIVES_DEFAULT_COMPANY_URL = 'admin/creatives/default_advertising_company';
export const AFFILIATE_PROGRAM_CREATIVES_DEFAULT_COMPANY_QUERY_KEY = 'affiliate-program.creatives.default_advertising_company';

export const AFFILIATE_PROGRAM_CREATIVES_SAVE_URL = 'admin/creatives/:id';
export const AFFILIATE_PROGRAM_CREATIVES_SAVE_MUTATION_KEY = 'affiliate-program.creatives.save';
